import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import {
  Department,
  DeptMember,
  NewDepartment,
  NewDeptMember,
} from "../../../Department";
import { decryption } from "../../../HelperFunctions";
import DepartmentKpi from "@/containers/Department/components/Department/DepartmentKpi";
import CreateDeptKpi from "@/containers/Department/components/Department/CreateDeptKpi";
import CreateKpiDuration from "@/containers/Department/components/Department/CreateKpiDuration";
import CreateEmployeeKpi from "@/containers/Department/components/Department/CreateEmployeeKpi";
import KpiDurationList from "@/containers/Department/components/Department/KpiDurationList";
import KpiView from "@/containers/Department/components/Department/KpiView";

export default () => {
  const permission = JSON.parse(localStorage?.getItem("permissions"));

  return (
    <Switch>
      <Route
        path="/department/list"
        render={() =>
          decryption(permission)?.includes("view_department") ? (
            <Department />
          ) : (
            <Redirect to="/404" />
          )
        }
      />
      <Route
        path="/department/new"
        render={() =>
          decryption(permission)?.includes("create_department") ? (
            <NewDepartment />
          ) : (
            <Redirect to="/404" />
          )
        }
      />

      <Route
        path="/department/kpi-create"
        render={() =>
          decryption(permission)?.includes("create_department") ? (
            <CreateDeptKpi />
          ) : (
            <Redirect to="/404" />
          )
        }
      />

      <Route
        path="/department/kpi-list"
        render={() =>
          decryption(permission)?.includes("create_department") ? (
            <DepartmentKpi />
          ) : (
            <Redirect to="/404" />
          )
        }
      />

      <Route
        path="/department/kpi-duration"
        render={() =>
          decryption(permission)?.includes("create_department") ? (
            <CreateKpiDuration />
          ) : (
            <Redirect to="/404" />
          )
        }
      />
      <Route
        path="/department/kpi-duration-list"
        render={() =>
          decryption(permission)?.includes("create_department") ? (
            <KpiDurationList />
          ) : (
            <Redirect to="/404" />
          )
        }
      />
      <Route
        path="/department/employee-kpi"
        render={() =>
          decryption(permission)?.includes("create_department") ? (
            <CreateEmployeeKpi />
          ) : (
            <Redirect to="/404" />
          )
        }
      />
      <Route
        path="/department/employee-kpi-view"
        render={() =>
          decryption(permission)?.includes("create_department") ? (
            <KpiView />
          ) : (
            <Redirect to="/404" />
          )
        }
      />
      {/* <Route
        path="/department/:id"
        render={(routeProps) =>
          decryption(permission)?.includes("create_department") ? (
            <DepartmentKpi {...routeProps} />
          ) : (
            <Redirect to="/404" />
          )
        }
      /> */}
      {/* <Route
        path="/department/:id"
        render={(routeProps) =>
          decryption(permission)?.includes("create_department") ? (
            <DepartmentKpi {...routeProps} />
          ) : (
            <Redirect to="/404" />
          )
        }
      /> */}

      <Route
        path="/department/member"
        render={() =>
          decryption(permission)?.includes("view_department_member") ? (
            <DeptMember />
          ) : (
            <Redirect to="/404" />
          )
        }
      />
    </Switch>
  );
};
